import { FC } from 'react';

import DealerSelect from './components/DealerSelect/DealerSelect';
import TicketsList from './components/TicketsList/TicketsList';
import { IndentedFlexWrapStyled, SidebarStyled, TextStyled } from './Sidebar.styled';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import UserInfo from 'components/UserInfo/UserInfo';

type SidebarPropsT = {
  isSidebarOpened: boolean;
};

const Sidebar: FC<SidebarPropsT> = ({ isSidebarOpened }) => {
  return (
    <SidebarStyled isSidebarOpened={isSidebarOpened}>
      <div>
        <IndentedFlexWrapStyled>
          <FlexContainer justify="center">
            <img src="/images/logo.png" alt="WarrChirp logo" />
          </FlexContainer>
          <TextStyled size="xs" color="grey">
            Warranty Status Report
          </TextStyled>
        </IndentedFlexWrapStyled>
        <DealerSelect />
        <TicketsList />
      </div>
      <FlexContainer align="start" direction="column-reverse">
        <UserInfo />
      </FlexContainer>
    </SidebarStyled>
  );
};

export default Sidebar;
